import catalogJson from '@/generated/catalog.json';
import appsWikiJson from '@/content/apps-wiki.json';
import { sortApps, type PublicApp } from '@/content/apps';
import { sortPlans, type PublicPlan } from '@/content/plans';

/**
 * Catálogo congelado no build (apps e planos da API pública).
 *
 * Serve para duas coisas: gerar o HTML de cada página com conteúdo de verdade,
 * e dar à primeira renderização no navegador os mesmos dados que o HTML já
 * tinha, para o React assumir a página sem piscar. Depois disso o site busca o
 * catálogo ao vivo normalmente.
 */
interface CatalogFile {
  fetchedAt: string;
  apps: PublicApp[];
  plans: PublicPlan[];
}

interface AppWikiEntry {
  title: string;
  subtitle: string;
  markdown: string;
}

const catalog = catalogJson as unknown as CatalogFile;
const appsWiki = appsWikiJson as Record<string, AppWikiEntry>;

export const catalogFetchedAt = catalog.fetchedAt;
export const buildApps: PublicApp[] = sortApps(catalog.apps);
export const buildPlans: PublicPlan[] = sortPlans(catalog.plans);

/** App aparece como página própria quando está disponível ou anunciado como em breve. */
export function publicCatalogApps(): PublicApp[] {
  return buildApps;
}

export function findBuildApp(slug: string): PublicApp | undefined {
  return buildApps.find((app) => app.slug === slug);
}

export function appWiki(slug: string): AppWikiEntry | undefined {
  return appsWiki[slug];
}

export function appPath(slug: string): string {
  return `/apps/${slug}`;
}
